const SAVE_FEEDBACK = process.env.REACT_APP_API_URL + "/saveFeedback";
var INTERVAL_TIMER;

export default class ChatWindowParticipantTagger {
  constructor(botName, botImage, gid, iid, mobile) {
    this.botName = botName;
    this.botImage = botImage;
    this.gid = gid;
    this.iid = iid;
    this.mobile = mobile;
  }

  start() {
    if (INTERVAL_TIMER) {
      clearInterval(INTERVAL_TIMER);
    }
    INTERVAL_TIMER = setInterval(this.addParticipantTags.bind(this), 200);
  }

  // Adds tags for user/bot above each block of messages
  addParticipantTags() {
    let msChatwindow = document.querySelector(
      "#chat_box .webchat__basic-transcript div ul"
    );
    if (msChatwindow) {
      let messageBubbles = msChatwindow.children;

      for (let row = 0; row < messageBubbles.length; row++) {
        // Ignore tags
        if (messageBubbles[row].className.includes("participant-tag")) {
          continue;
        }

        // Check if this is a message at the start of a block
        // (by checking if a message AND previous message didn't exist or was the last of a block)
        let isFirst = row === 0;
        let isFirstOfBlock = false;
        let alreadyHasTag = false;
        if (!isFirst) {
          if (
            messageBubbles[row].querySelector(".webchat__bubble--from-user")
          ) {
            isFirstOfBlock = !messageBubbles[row - 1].querySelector(
              ".webchat__bubble--from-user"
            );
          } else {
            isFirstOfBlock = messageBubbles[row - 1].querySelector(
              ".webchat__bubble--from-user"
            );
          }

          alreadyHasTag =
            messageBubbles[row - 1].className.includes("participant-tag");
        }
        if ((isFirst || isFirstOfBlock) && !alreadyHasTag) {
          let tag;
          // Check if this is a user/bot block
          if (
            messageBubbles[row].querySelector(".webchat__bubble--from-user")
          ) {
            tag = this.getUserTag();
          } else {
            tag = this.getBotTag();
          }

          msChatwindow.insertBefore(tag, messageBubbles[row]);
        }
        let isLast = false;
        let alreadyHasFeed = null;
        let statusDiv = messageBubbles[row].querySelector(
          ".webchat__stacked-layout__status span"
        );
        if (statusDiv === null) {
          statusDiv = messageBubbles[row].querySelector(
            ".webchat__carousel-filmstrip__status span"
          );
        }
        if (row !== 0 && statusDiv !== null) {
          if (row < messageBubbles.length) {
            if (messageBubbles[row + 1] !== undefined) {
              if (
                messageBubbles[row + 1].querySelector(
                  ".webchat__bubble--from-user"
                )
              ) {
                isLast = true;
              }
              alreadyHasFeed = statusDiv.querySelector(".feedback-tag");
            } else {
              isLast = true;
              alreadyHasFeed = statusDiv.querySelector(".feedback-tag");
            }
          }
        }
        if (row !== 0 && isLast && alreadyHasFeed === null) {
          let msgId,
            conId,
            elementName,
            markdownTextLen,
            feedback_response,
            btnShow,
            messageType;
          let li = statusDiv.parentElement.parentElement;
          let bubbleWidth = false;
          let isAdaptingCard = false;
          let isZenDesk = false;
          if (li !== null) {
            let childdiv = li.children;
            if (childdiv[0].querySelector(".herocard-container")) {
              let herocard = childdiv[0].querySelector(".herocard-container");
              msgId = herocard.getAttribute("data-activity-id");
              conId = herocard.getAttribute("data-con-id");
              feedback_response = herocard.getAttribute("data-feedback");
              btnShow = herocard.getAttribute("data-view-btn");
              messageType = herocard.getAttribute("data-msg-type");
              const zendesk = herocard.getAttribute("data-inzendesk");
              isZenDesk = zendesk === "false" ? false : true;
            } else if (childdiv[0].querySelector(".videocard-container")) {
              let videocard = childdiv[0].querySelector(".videocard-container");
              msgId = videocard.getAttribute("data-activity-id");
              conId = videocard.getAttribute("data-con-id");
              feedback_response = videocard.getAttribute("data-feedback");
              btnShow = videocard.getAttribute("data-view-btn");
              messageType = videocard.getAttribute("data-msg-type");
              const zendesk = videocard.getAttribute("data-inzendesk");
              isZenDesk = zendesk === "false" ? false : true;
            } else if (childdiv[0].querySelector(".markdown")) {
              let herocard = childdiv[0].querySelector(".markdown");
              msgId = herocard.getAttribute("data-activity-id");
              conId = herocard.getAttribute("data-con-id");
              feedback_response = herocard.getAttribute("data-feedback");
              btnShow = herocard.getAttribute("data-view-btn");
              messageType = herocard.getAttribute("data-msg-type");
              let width = herocard.getAttribute("width");
              elementName = "markdown";
              bubbleWidth = width === "true" ? true : false;
              markdownTextLen = herocard.getAttribute("text-len");
              const zendesk = herocard.getAttribute("data-inzendesk");
              isZenDesk = zendesk === "false" ? false : true;
            } else if (childdiv[0].querySelector(".ac-adaptiveCard")) {
              isAdaptingCard = true;
            }
          }
          let tag = this.getBotFeedBack(msgId, conId, feedback_response);

          if (
            !messageBubbles[row].querySelector(".webchat__bubble--from-user")
          ) {
            let layoutMsg = messageBubbles[row].querySelector(
              ".webchat__stacked-layout__message"
            );
            if (layoutMsg !== null && bubbleWidth === true) {
              if (markdownTextLen > 50 && markdownTextLen < 60) {
                tag.classList.add("feed-left-message-min");
              } else {
                tag.classList.add("feed-left-message");
              }
            }
            let attecMsg = messageBubbles[row].querySelector(
              ".webchat__stacked-layout__attachment"
            );
            if (attecMsg !== null) {
              let formMsg = attecMsg.querySelector(
                ".webchat__adaptive-card-renderer"
              );
              if (formMsg !== null) {
                let groupForm = formMsg.querySelector(".ac-textBlock p");
                if (
                  groupForm.innerHTML.includes("Conference") ||
                  groupForm.innerHTML.includes("Long Stay Enquiry")
                ) {
                  if (this.mobile === "true") {
                    tag.classList.add("feed-left-attachform-conference-mobile");
                  } else {
                    tag.classList.add("feed-left-attachform-conference");
                  }
                } else {
                  tag.classList.add("feed-left-attachform");
                }
              } else {
                if (this.mobile === "true") {
                  tag.classList.add("feed-left-attachment_mobile");
                } else {
                  tag.classList.add("feed-left-attachment");
                }
              }
            }
            let herocardCarousel = messageBubbles[row].querySelector(
              ".webchat__carousel-layout .herocard-container"
            );
            if (herocardCarousel !== null) {
              if (this.mobile === "true") {
                tag.classList.add("feed-left-attachment-carousel_mobile");
              } else {
                tag.classList.add("feed-left-attachment-carousel");
              }
              let get = messageBubbles[row].querySelector(
                ".webchat__carousel-filmstrip__attachments"
              );
              let textarea = get.getElementsByClassName("herocard-text-area");
              if (textarea.length > 0) {
                let herocardTextArea = herocardCarousel.querySelector(
                  ".herocard-text-area"
                );
                if (herocardTextArea === null) {
                  if (this.mobile === "true") {
                    tag.style.bottom = "0.7rem";
                  } else {
                    tag.style.bottom = "0.8rem";
                  }
                }
              }
            }
            let videocardCarousel = messageBubbles[row].querySelector(
              ".webchat__carousel-layout .videocard-container"
            );
            if (videocardCarousel != null) {
              if (this.mobile === "true") {
                tag.classList.add("feed-left-carousel-layout_mobile");
              } else {
                tag.classList.add("feed-left-carousel-layout");
              }
              let get = messageBubbles[row].querySelector(
                ".webchat__carousel-filmstrip__attachments"
              );
              let textarea = get.getElementsByClassName("videocard-text-area");
              if (textarea.length > 0) {
                let videocardTextArea = videocardCarousel.querySelector(
                  ".videocard-text-area"
                );
                if (videocardTextArea === null) {
                  if (this.mobile === "true") {
                    tag.style.bottom = "3rem";
                  } else {
                    tag.style.bottom = "0.8rem";
                  }
                }
              }
            }
            statusDiv.append(tag);
            if (elementName === "markdown" && bubbleWidth === false) {
              statusDiv.querySelector(".feedback-tag").style.display = "none";
            }
          }
          if (messageType === "Fallback" || messageType === "Welcome") {
            tag.remove();
          }
          if (isAdaptingCard === true) {
            tag.remove();
          }
          if (
            btnShow !== undefined &&
            btnShow !== null &&
            btnShow.split("|")[1] === "0000000"
          ) {
            tag.remove();
          }
          if (isZenDesk === true) {
            tag.remove();
          }
          let webchat_basic = document.getElementsByClassName(
            "webchat__basic-transcript"
          );
          let webchat_suggested_action = document.getElementsByClassName("webchat__suggested-actions");
          // console.log(265, webchat_suggested_action)
          let webchat__basic_transcript__transcript = document.getElementsByClassName("webchat__basic-transcript__transcript");
          if (webchat_suggested_action.length > 0) {
            if (this.mobile === "true") {
              webchat_suggested_action[0].classList.add("webchat__suggested-actions-mobile");
              webchat__basic_transcript__transcript[0].style.paddingBottom = 3 + "rem";
            } else {
              webchat__basic_transcript__transcript[0].style.paddingBottom = 3 + "rem";
            }
            webchat_basic[0].classList.add("transcript-suggest-mobile");
          }
          else {
            webchat_basic[0].classList.remove("transcript-suggest-mobile");
          }
        }
      }
    } else {
      // console.error(`Participant Tagger: Couldn't find the chatWindow.`);
    }
  }

  getUserTag() {
    let tag = document.createElement("li");
    tag.innerHTML = "You";
    tag.className = "participant-tag participant-tag-user";
    tag.setAttribute("role", "listitem");
    return tag;
  }

  getBotTag() {
    let tag = document.createElement("li");
    tag.innerHTML = `<div class='participant-tag-bot-bubble' style="background-image: url('${this.botImage}')"> </div> 
            <div class='participant-tag-bot-text'> ${this.getAssistantName(this.botName)} </div>`;
    tag.className = "participant-tag participant-tag-bot";
    tag.setAttribute("role", "listitem");
    return tag;
  }
  getAssistantName(assistantDetail) {
    var assistantName = "Jenni";
    if (assistantDetail.length > 0) {
      var data = assistantDetail.filter(k => k.locale === localStorage.getItem(this.iid + "-language"));
      if (data.length === 0) {
        assistantName = assistantDetail.filter(k => k.locale === "en")[0].name;
      } else {
        assistantName = data[0].name;
      }
    }

    return assistantName;
  }
  // Called when chat reset so the tags don't get orphaned and sit around
  clearTags() {
    let tags = document.querySelectorAll(".participant-tag");
    for (let tag of tags) {
      tag.remove();
    }
  }
  TanslateWasHelpFullText(locale) {
    switch (locale) {
      case "af":
        return "Het hierdie gehelp?";
      case "ar":
        return "هل كان هذا مفيدا؟";
      case "de":
        return "War dies hilfreich?";
      case "es":
        return "¿Fue útil?";
      case "fr":
        return "Est-ce que cela a été utile?";
      case "hi":
        return "क्या ये सहायक था?";
      case "id":
        return "Apakah ini membantu?";
      case "ja":
        return "これは役に立ちましたか？";
      case "ko":
        return "도움이 되었나요?";
      case "mi":
        return "I awhina tenei?";
      case "ru":
        return "Было ли это полезно?";
      case "tl":
        return "Nakakatulong ba ito?";
      case "th":
        return "สิ่งนี้มีประโยชน์หรือไม่?";
      case "vi":
        return "Là hữu ích không?";
      case "zh":
        return "这个有帮助吗？";
      case "zh-TW":
        return "這個有幫助嗎？";
      case "ar":
        return "هل كان هذا مفيدا؟";
      default:
        return "Was this helpful?";
    }
  }

  getBotFeedBack(msgId, conId, feedback_response) {
    let gid = this.gid;
    let iid = this.iid;
    let tag = document.createElement("div");
    tag.className = "feedback-tag chat_feedback_container";

    let tagBody = document.createElement("div");
    tagBody.className = "feedback-tag chat_feedBack_body";
    tag.appendChild(tagBody);

    let tagBodyResponse = document.createElement("div");
    tagBodyResponse.className = "feedback-response-body";
    tagBodyResponse.style.display = "none";
    tag.appendChild(tagBodyResponse);
    let tagFeedbackText = document.createElement("div");
    tagFeedbackText.className = "chat_feedback_text";
    tagFeedbackText.innerText = this.TanslateWasHelpFullText(
      localStorage.getItem(this.iid + "-language")
    );
    tagBody.appendChild(tagFeedbackText);

    let likeButton = document.createElement("button");
    let dislikeButton = document.createElement("button");
    let orignalBtn = document.createElement("button");
    likeButton.className = "btn_like";
    likeButton.value = msgId;
    likeButton.innerHTML =
      "<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='currentColor'><path d='M21.3,10.08A3,3,0,0,0,19,9H14.44L15,7.57A4.13,4.13,0,0,0,11.11,2a1,1,0,0,0-.91.59L7.35,9H5a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17.73a3,3,0,0,0,2.95-2.46l1.27-7A3,3,0,0,0,21.3,10.08ZM7,20H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H7Zm13-7.82-1.27,7a1,1,0,0,1-1,.82H9V10.21l2.72-6.12A2.11,2.11,0,0,1,13.1,6.87L12.57,8.3A2,2,0,0,0,14.44,11H19a1,1,0,0,1,.77.36A1,1,0,0,1,20,12.18Z'></path></svg>";
    likeButton.addEventListener("click", function () {
      if (gid !== undefined && conId !== undefined) {
        tagBody.style.display = "none";
        tagBodyResponse.style.display = "block";
        orignalBtn.style.color = "green";
        orignalBtn.innerHTML =
          "<svg xmlns='http://www.w3.org/2000/svg' style='margin-bottom:5px;margin-left:-1px' width='20' height='20' viewBox='0 0 24 24' fill='currentColor'><path d='M21.3,10.08A3,3,0,0,0,19,9H14.44L15,7.57A4.13,4.13,0,0,0,11.11,2a1,1,0,0,0-.91.59L7.35,9H5a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17.73a3,3,0,0,0,2.95-2.46l1.27-7A3,3,0,0,0,21.3,10.08ZM7,20H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H7Zm13-7.82-1.27,7a1,1,0,0,1-1,.82H9V10.21l2.72-6.12A2.11,2.11,0,0,1,13.1,6.87L12.57,8.3A2,2,0,0,0,14.44,11H19a1,1,0,0,1,.77.36A1,1,0,0,1,20,12.18Z'></path></svg>";

        let body = {
          groupId: gid,
          messageId: this.value,
          feedback: "Like",
        };
        try {
          fetch(`${SAVE_FEEDBACK}`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          });
        } catch (error) { }
        let getOldFeed = JSON.parse(
          localStorage.getItem(iid + "-chatfeedback")
        );
        if (getOldFeed === null) {
          getOldFeed = [];
        }
        let new_chat_state = [...getOldFeed];
        let getIndex = new_chat_state.findIndex(
          (index) => index.messageId === this.value
        );
        if (getIndex === -1) {
          new_chat_state.push({ messageId: this.value, feedback: "Like" });
        } else {
          new_chat_state[getIndex].messageId = this.value;
          new_chat_state[getIndex].feedback = "Like";
        }
        localStorage.setItem(
          iid + "-chatfeedback",
          JSON.stringify(new_chat_state)
        );
      }
    });

    tagBody.appendChild(likeButton);

    dislikeButton.className = "btn_dislike";
    dislikeButton.value = msgId;
    dislikeButton.innerHTML =
      "<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='currentColor'><path d='M19,2H6.27A3,3,0,0,0,3.32,4.46l-1.27,7A3,3,0,0,0,5,15H9.56L9,16.43A4.13,4.13,0,0,0,12.89,22a1,1,0,0,0,.91-.59L16.65,15H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2ZM15,13.79l-2.72,6.12a2.13,2.13,0,0,1-1.38-2.78l.53-1.43A2,2,0,0,0,9.56,13H5a1,1,0,0,1-.77-.36A1,1,0,0,1,4,11.82l1.27-7a1,1,0,0,1,1-.82H15ZM20,12a1,1,0,0,1-1,1H17V4h2a1,1,0,0,1,1,1Z'></path></svg>";

    dislikeButton.addEventListener("click", function () {
      if (gid !== undefined && conId !== undefined) {
        tagBody.style.display = "none";
        tagBodyResponse.style.display = "block";
        orignalBtn.style.color = "red";
        orignalBtn.innerHTML =
          "<svg xmlns='http://www.w3.org/2000/svg' style='margin-bottom:1px;margin-left:-1px' width='20' height='20' viewBox='0 0 24 24' fill='currentColor'><path d='M19,2H6.27A3,3,0,0,0,3.32,4.46l-1.27,7A3,3,0,0,0,5,15H9.56L9,16.43A4.13,4.13,0,0,0,12.89,22a1,1,0,0,0,.91-.59L16.65,15H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2ZM15,13.79l-2.72,6.12a2.13,2.13,0,0,1-1.38-2.78l.53-1.43A2,2,0,0,0,9.56,13H5a1,1,0,0,1-.77-.36A1,1,0,0,1,4,11.82l1.27-7a1,1,0,0,1,1-.82H15ZM20,12a1,1,0,0,1-1,1H17V4h2a1,1,0,0,1,1,1Z'></path></svg>";

        let body = {
          groupId: gid,
          messageId: this.value,
          feedback: "Dislike",
        };
        try {
          fetch(`${SAVE_FEEDBACK}`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          });
        } catch (error) { }
        let feedback_popup = document.getElementById("feedback_popup");
        if (feedback_popup !== null) {
          document
            .getElementById("feedback_popup_body")
            .classList.remove("closepop");
          document.getElementById("feedback_popup_body").classList.add("area");
          let feedBackButton = document.getElementById("feedback_button");

          if (feedBackButton !== null) {
            feedBackButton.value = this.value;
          }
          feedback_popup.style.display = "block";

        }
        let getOldFeed = JSON.parse(
          localStorage.getItem(iid + "-chatfeedback")
        );
        if (getOldFeed === null) {
          getOldFeed = [];
        }
        let new_chat_state = [...getOldFeed];
        let getIndex = new_chat_state.findIndex(
          (index) => index.messageId === this.value
        );
        if (getIndex === -1) {
          new_chat_state.push({ messageId: this.value, feedback: "Dislike" });
        } else {
          new_chat_state[getIndex].messageId = this.value;
          new_chat_state[getIndex].feedback = "Dislike";
        }
        localStorage.setItem(
          iid + "-chatfeedback",
          JSON.stringify(new_chat_state)
        );
      }
    });

    tagBody.appendChild(dislikeButton);

    orignalBtn.className = "btn_orginal";
    orignalBtn.value = msgId;
    orignalBtn.addEventListener("click", function () {
      if (gid !== undefined && conId !== undefined) {
        tagBody.style.display = "flex";
        tagBodyResponse.style.display = "none";
        let body = {
          groupId: gid,
          messageId: this.value,
          feedback: "None",
        };
        try {
          fetch(`${SAVE_FEEDBACK}`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          });
        } catch (error) { }
        let getOldFeed = JSON.parse(
          localStorage.getItem(iid + "-chatfeedback")
        );
        if (getOldFeed === null) {
          getOldFeed = [];
        }
        let new_chat_state = [...getOldFeed];
        let getIndex = new_chat_state.findIndex(
          (index) => index.messageId === this.value
        );
        if (getIndex === -1) {
          new_chat_state.push({ messageId: this.value, feedback: "None" });
        } else {
          new_chat_state[getIndex].messageId = this.value;
          new_chat_state[getIndex].feedback = "None";
        }
        localStorage.setItem(
          iid + "-chatfeedback",
          JSON.stringify(new_chat_state)
        );
      }
    });
    tagBodyResponse.appendChild(orignalBtn);
    if (feedback_response === "Like") {
      tagBody.style.display = "none";
      tagBodyResponse.style.display = "block";
      orignalBtn.style.color = "green";
      orignalBtn.innerHTML =
        "<svg xmlns='http://www.w3.org/2000/svg' style='margin-bottom:5px;margin-left:-1px' width='20' height='20' viewBox='0 0 24 24' fill='currentColor'><path d='M21.3,10.08A3,3,0,0,0,19,9H14.44L15,7.57A4.13,4.13,0,0,0,11.11,2a1,1,0,0,0-.91.59L7.35,9H5a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17.73a3,3,0,0,0,2.95-2.46l1.27-7A3,3,0,0,0,21.3,10.08ZM7,20H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H7Zm13-7.82-1.27,7a1,1,0,0,1-1,.82H9V10.21l2.72-6.12A2.11,2.11,0,0,1,13.1,6.87L12.57,8.3A2,2,0,0,0,14.44,11H19a1,1,0,0,1,.77.36A1,1,0,0,1,20,12.18Z'></path></svg>";
    }
    if (feedback_response === "Dislike") {
      tagBody.style.display = "none";
      tagBodyResponse.style.display = "block";
      orignalBtn.style.color = "red";
      orignalBtn.innerHTML =
        "<svg xmlns='http://www.w3.org/2000/svg' style='margin-bottom:1px;margin-left:-1px' width='20' height='20' viewBox='0 0 24 24' fill='currentColor'><path d='M19,2H6.27A3,3,0,0,0,3.32,4.46l-1.27,7A3,3,0,0,0,5,15H9.56L9,16.43A4.13,4.13,0,0,0,12.89,22a1,1,0,0,0,.91-.59L16.65,15H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2ZM15,13.79l-2.72,6.12a2.13,2.13,0,0,1-1.38-2.78l.53-1.43A2,2,0,0,0,9.56,13H5a1,1,0,0,1-.77-.36A1,1,0,0,1,4,11.82l1.27-7a1,1,0,0,1,1-.82H15ZM20,12a1,1,0,0,1-1,1H17V4h2a1,1,0,0,1,1,1Z'></path></svg>";
    }
    return tag;
  }
}
